"use strict";

var _classCallCheck = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
var _inherits = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");
var _createSuper = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");
exports.__esModule = true;
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _transitionEnd = _interopRequireDefault(require("dom-helpers/transitionEnd"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["direction", "children", "onTransitionEnd"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var DirectionPropType = _propTypes.default.oneOf(['left', 'right', 'top', 'bottom']);
var prefix = 'rw-calendar-transition';
var active = 'rw-calendar-transition-active';
var next = 'rw-calendar-transition-next';
var prev = 'rw-calendar-transition-prev';
var clone = function clone(el, cls) {
  return el && /*#__PURE__*/_react.default.cloneElement(el, {
    className: (0, _classnames.default)(el.props.className, prefix, cls)
  });
};
var SlideTransitionGroup = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(SlideTransitionGroup, _react$default$Compon);
  var _super = _createSuper(SlideTransitionGroup);
  function SlideTransitionGroup(args) {
    var _this;
    _classCallCheck(this, SlideTransitionGroup);
    _this = _super.call(this, args);
    _this.handleTransitionEnd = function (hadFocus) {
      _this.isTransitioning = false;
      var current = _this.container.current.lastChild;
      if (_this.props.onTransitionEnd) _this.props.onTransitionEnd(current, hadFocus);
    };
    _this.current = _this.props.children;
    _this.container = /*#__PURE__*/_react.default.createRef();
    _this.state = {
      prevClasses: '',
      currentClasses: ''
    };
    return _this;
  }
  _createClass(SlideTransitionGroup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;
      if (!this.flush || this.isTransitioning) return;
      this.flush = false;
      this.isTransitioning = true;
      var previous = this.container.current.firstChild;
      var hadFocus = document.activeElement && previous.contains(document.activeElement);
      this.setState({
        prevClasses: '',
        currentClasses: next
      }, function () {
        var current = _this2.container.current.lastChild;
        current.clientHeight; // eslint-disable-line

        _this2.setState({
          prevClasses: prev,
          currentClasses: (0, _classnames.default)(next, active)
        }, function () {
          (0, _transitionEnd.default)(current, function () {
            _this2.prev = null;
            if (_this2.current.key !== _this2.props.children.key) {
              _this2.current = _this2.props.children;
            }
            _this2.setState({
              prevClasses: '',
              currentClasses: ''
            }, function () {
              return _this2.handleTransitionEnd(hadFocus);
            });
          });
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        direction = _this$props.direction,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, _excluded);
      if (!this.isTransitioning) {
        if (this.current.key !== children.key) {
          this.prev = this.current;
          this.flush = true;
        }
        this.current = children;
      }
      var _this$state = this.state,
        prevClasses = _this$state.prevClasses,
        currentClasses = _this$state.currentClasses;
      return /*#__PURE__*/_react.default.createElement("div", _extends({}, props, {
        ref: this.container,
        className: (0, _classnames.default)("rw-calendar-transition-group", direction === 'top' && 'rw-calendar-transition-top', direction === 'right' && 'rw-calendar-transition-right', direction === 'bottom' && 'rw-calendar-transition-bottom', direction === 'left' && 'rw-calendar-transition-left')
      }), clone(this.prev, prevClasses), clone(this.current, currentClasses));
    }
  }]);
  return SlideTransitionGroup;
}(_react.default.Component);
SlideTransitionGroup.defaultProps = {
  direction: 'left'
};
SlideTransitionGroup.propTypes = {
  direction: DirectionPropType,
  onTransitionEnd: _propTypes.default.func
};
var _default = SlideTransitionGroup;
exports.default = _default;